import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { ArticlesContext } from "../../contexts/ArticlesContext";
import { AOSProps } from "../../global/types";
import { Arrow } from "../Icons/Arrow";

const TopFAQ: React.FC<AOSProps> = ({ dataAos, dataAosDelay }) => {
  const articlesContext = useContext(ArticlesContext);

  const topFAQArticles = articlesContext.articles.filter(
    article => article.featured_faq
  );

  return (
    <div className="top-faq">
      {topFAQArticles.map(article => (
        <Link
          className="top-faq__item"
          key={article.id}
          to={`/article/${article.id}`}
          data-aos={dataAos}
          data-aos-delay={dataAosDelay}
        >
          <Arrow />
          <span>{article.subtitle}</span>
        </Link>
      ))}
    </div>
  );
};

export default TopFAQ;
